class Slider {
	constructor() {
		let cache = {};

		let initFunc = () => {
			initCache();
			registerEvents();
		};

		let initCache = () => {
			cache.images = Array.from(document.querySelectorAll(".slider-image"));
			cache.currentIndex = 0;
		};

		let registerEvents = () => {
			shuffleImages();

			displayImage(cache.currentIndex);

			setInterval(() => {
				cache.currentIndex = (cache.currentIndex + 1) % cache.images.length;
				displayImage(cache.currentIndex);
			}, 4000);
		};

		let shuffleImages = () => {
			for (let i = cache.images.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[cache.images[i], cache.images[j]] = [cache.images[j], cache.images[i]];
			}
		};

		let displayImage = (index) => {
			cache.images.forEach((img, i) => {
				img.style.opacity = i === index ? "1" : "0";
			});
		};

		initFunc();
	}
}

export { Slider };
